export default __webpack_public_path__ + "static/media/courierMarketplace.48ff1a48.png";